var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    className: "app-icon app-icon--normal",
    "data-identify-element": 770,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    "data-identify-element": 771
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DADFE3",
    d: "M28.476 20.815A9.375 9.375 0 0119.1 30.19a9.375 9.375 0 01-9.375-9.375A9.375 9.375 0 0119.1 11.44a9.375 9.375 0 019.375 9.375",
    "data-identify-element": 772
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F1",
    d: "M17.164 5.853V2.751h2.069v3.102",
    "data-identify-element": 773
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.164 5.853V2.751h2.069v3.102",
    "data-identify-element": 774
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F1",
    d: "M16.13 2.75h4.137",
    "data-identify-element": 775
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.13 2.75h4.137",
    "data-identify-element": 776
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F1",
    d: "M26.025 8.371l2.07-2.069",
    "data-identify-element": 777
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26.025 8.371l2.07-2.069",
    "data-identify-element": 778
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6F7C87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M31.646 19.302c0 7.427-6.02 13.448-13.448 13.448-7.428 0-13.449-6.021-13.449-13.448 0-7.427 6.022-13.448 13.45-13.448 7.426 0 13.447 6.02 13.447 13.448z",
    "data-identify-element": 779
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6F7C87",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.513 19.302a9.315 9.315 0 01-9.315 9.315 9.314 9.314 0 01-9.315-9.315 9.314 9.314 0 019.315-9.315 9.315 9.315 0 019.315 9.315z",
    "data-identify-element": 780
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F1",
    d: "M29.54 5.502a.845.845 0 10-1.69 0 .845.845 0 001.69 0",
    "data-identify-element": 781
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.694 3.157a2.348 2.348 0 00-2.345 2.345 2.348 2.348 0 002.345 2.345 2.348 2.348 0 002.345-2.345 2.348 2.348 0 00-2.345-2.345m0 1.5a.845.845 0 11.001 1.69.845.845 0 010-1.69",
    "data-identify-element": 782
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADFE3",
    d: "M17.006 20.68l.898-8.546c.037-.357.557-.357.594 0l.891 8.482c.063.596-.286 1.19-.863 1.347a1.202 1.202 0 01-1.52-1.283",
    "data-identify-element": 783
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.201 11.866a.29.29 0 00-.297.268l-.898 8.546a1.202 1.202 0 001.519 1.283c.578-.157.927-.752.864-1.347l-.89-8.482a.29.29 0 00-.298-.268",
    "data-identify-element": 784
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLogs);
export default __webpack_public_path__ + "static/media/timeLogs.a3bda478a067c1118f89af8c0dd582a8.svg";
export { ForwardRef as ReactComponent };